import { CreditCard, Camera, QrCode, Bell } from 'lucide-react';

const steps = [
  { step: 1, title: 'اشترك', description: 'اختر الباقة المناسبة وادفع عبر زين كاش', icon: CreditCard },
  { step: 2, title: 'وثّق سيارتك', description: 'ارفع صورة سيارتك مع رقم اللوحة للتحقق', icon: Camera },
  { step: 3, title: 'اعرض الرمز', description: 'اذهب لأي مغسلة شريكة واعرض رمز QR', icon: QrCode },
  { step: 4, title: 'استلم سيارتك', description: 'سنرسل لك إشعار عندما تكون جاهزة', icon: Bell },
];

export default function HowItWorksSection() {
  return (
    <section className="py-16 px-4 bg-surface">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12 anim-fade-up">
          <h2 className="text-2xl md:text-3xl font-bold text-text-brand font-cairo mb-2">كيف يعمل؟</h2>
          <p className="text-text-muted">٤ خطوات بسيطة</p>
        </div>

        {/* Step circles with connecting dashed line */}
        <div className="relative">
          {/* Dashed connecting line */}
          <div className="hidden md:block absolute top-6 right-6 left-6 h-0.5 border-t-2 border-dashed border-primary-200 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-4 relative z-10">
            {steps.map((item, i) => {
              const Icon = item.icon;
              return (
                <div
                  key={item.step}
                  className={`anim-fade-up delay-${i + 1} flex flex-col items-center text-center group`}
                >
                  {/* Circle with number */}
                  <div className="w-12 h-12 rounded-full bg-primary-600 text-white flex items-center justify-center font-bold text-lg shadow-md shadow-primary-200 mb-4 group-hover:scale-110 transition-transform">
                    {item.step}
                  </div>

                  {/* Icon */}
                  <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center mb-3 shadow-sm">
                    <Icon className="w-5 h-5 text-primary-600" />
                  </div>

                  <h3 className="font-bold text-text-brand mb-1">{item.title}</h3>
                  <p className="text-text-muted text-sm leading-relaxed">{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
